import { TableFormatHelper } from './TableFormatHelper';

export const CsvFormatHelper = {
    baseDateTimePropertyList: ['dateCreateAt', 'dateModifyAt'],

    getDefaultDateTimePropertyList(): string[] {
        return [...CsvFormatHelper.baseDateTimePropertyList];
    },

    formatDateTimeCsvValue(value: string, key: string): string {
        if (this.baseDateTimePropertyList.includes(key)) {
            return TableFormatHelper.formatDateTime(value as string);
        }
        return value;
    }
};
